/**
 * Estados de una sección cuando no hay nada que mostrar (`EstadoVacio`) o no se pudo cargar
 * (`EstadoError`, con «Reintentar»). Mismo marco para ambos: ícono en una insignia, título, texto y
 * una acción opcional. El error se anuncia (`role="alert"`).
 */
import type { ReactNode } from 'react';
import { Icono } from './Icono';
import './EstadoSeccion.css';

export function EstadoVacio({
  titulo,
  texto,
  accion,
}: {
  titulo: string;
  texto: string;
  /** Botón opcional (p. ej. «Nueva tarea» si la persona puede escribir). */
  accion?: ReactNode;
}) {
  return (
    <div className="estado-seccion">
      <span className="estado-seccion__icono">
        <Icono nombre="vacio" tamano={20} />
      </span>
      <h2 className="estado-seccion__titulo">{titulo}</h2>
      <p className="estado-seccion__texto">{texto}</p>
      {accion}
    </div>
  );
}

export function EstadoError({
  texto,
  onReintentar,
  reintentando = false,
  children,
}: {
  texto: string;
  onReintentar: () => void;
  /** Mientras vuelve a pedir: el botón queda deshabilitado con su giro. */
  reintentando?: boolean;
  /** Acciones extra junto a «Reintentar» (p. ej. «Cerrar» en la ficha). */
  children?: ReactNode;
}) {
  return (
    <div className="estado-seccion estado-seccion--error" role="alert">
      <span className="estado-seccion__icono">
        <Icono nombre="alerta" tamano={20} />
      </span>
      <h2 className="estado-seccion__titulo">No pudimos cargar esto</h2>
      <p className="estado-seccion__texto">{texto}</p>
      <div className="estado-seccion__acciones">
        <button
          type="button"
          className="boton boton--con-icono"
          disabled={reintentando}
          onClick={onReintentar}
        >
          <Icono nombre="recargar" />
          {reintentando ? 'Reintentando…' : 'Reintentar'}
        </button>
        {children}
      </div>
    </div>
  );
}
